import React, { useEffect } from 'react'
import { ArrowBack } from '@mui/icons-material'
import { useLocation, useNavigate } from 'react-router-dom'
import { any, func, bool } from 'prop-types'
import { IconButton, styled } from '@mui/material'

const StyledDiv = styled('div')``

const GetPageName = ({ onTest, routes, isExemplar }) => {
  const navigate = useNavigate()

  const location = useLocation()

  const atualPath = routes.find(route => route.path === location.pathname)
  let result = false

  useEffect(() => {
    onTest(location.pathname.includes('/leitura/livro/') || false)
  }, [location.pathname])

  if (atualPath !== undefined) {
    if (atualPath.secondary !== undefined) {
      result = true
    }
  } else if (isExemplar) {
    result = true
  }
  let name = ''
  if (atualPath?.name) {
    name = atualPath?.name
  }
  if (isExemplar) {
    const url = decodeURI(location.pathname)
    const pos = url.indexOf('&name:')

    const obran = url.slice(pos + 6).toLowerCase()
    name = obran
  }
  return (
    <div
      style={{
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center'
      }}
    >
      {result && (
        <IconButton
          color="leitura"
          sx={{ marginRight: '0.5rem' }}
          onClick={() => {
            navigate(-1)
          }}
        >
          <ArrowBack />
        </IconButton>
      )}
      <StyledDiv
        sx={{
          textOverflow: 'ellipsis',
          maxWidth: '62vw',
          overflow: 'hidden',
          fontSize: { xs: '1.1rem', md: '1.5rem' },
          marginLeft: { xs: '0', md: '1' }
        }}
      >
        {name}
      </StyledDiv>
    </div>
  )
}
GetPageName.propTypes = {
  routes: any,
  isExemplar: bool,
  onTest: func
}

export default GetPageName
